import { setSportId } from "../../helpers";
/**
 * Group markets received against cardConfiguration
 * @param markets
 * @param cardConfig
 */
export const groupMarketsBySport = (markets, cardConfig) => {
    let marketsBySport = {};
    let sportIds = Object.keys(cardConfig);
    let currentSportId;
    sportIds.forEach(x => marketsBySport[x] = []);
    markets.forEach(m => {
        currentSportId = setSportId(sportIds, m);
        marketsBySport[currentSportId].push(m);
    });
    // Object.keys(cardConfig).map(sportId => {
    //     let availableMarkets = markets.filter(m => {
    //         currentSportId = setSportId(sportIds, m);
    //         return currentSportId === sportId.toString()
    //     });
    //     marketsBySport[sportId] = availableMarkets;
    // });
    return marketsBySport;
};
//# sourceMappingURL=groupMarketsBySport.js.map